import { KNOWN_HOSTS, DEFAULT_HOST } from '../config.js';

export function isLanPreviewHost() {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  const host = window.location.hostname || '';

  if (['localhost', '127.0.0.1', '[::1]'].includes(host) && window.location.port !== '6060') {
    return true;
  }

  if (/^192\.168\./.test(host) || /^10\./.test(host)) {
    return true;
  }

  const match = host.match(/^172\.(\d+)\./);
  return !!(match && Number(match[1]) >= 16 && Number(match[1]) <= 31);
}

// Detect server address from the URL.
export function detectServerAddress() {
  let host = DEFAULT_HOST;

  if (typeof window.location == 'object') {
    if (isLanPreviewHost()) {
      return KNOWN_HOSTS.fox || DEFAULT_HOST;
    }
    if (
      window.location.protocol == 'file:' ||
      ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
    ) {
      host = KNOWN_HOSTS.local;

    } else if (window.location.hostname) {
      host = window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
    }
  }

  return host;
}

// Detect whether Tinode connection must be secure.
export function isSecureConnection() {
  if (typeof window.location == 'object') {
    // LAN preview itself is HTTP, but the remote Tinode server is WSS.
    if (isLanPreviewHost()) {
      return true;
    }

    return window.location.protocol == 'https:';
  }

  return false;
}

export function isLocalHost() {
  if (typeof window.location == 'object') {
    return ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
  }

  return false;
}
